import {
  CrystallizeProductTypeValues,
  isPhysicalProduct,
} from '@/integrations/crystallize/types/constants';
import { ParsedProductVariant } from '@/ui/components/pages/ProductDetail/types/ParsedProductVariant';
import { DEFAULT_OUT_OF_STOCK_THRESHOLD } from '@/utils/constants';

export function isDigitalProductVariantInStock(variant?: ParsedProductVariant) {
  if (!variant) {
    return false;
  }
  // If product variant has a global availability (toggle in crystallize, primarly used by digital products), warehouse chunks and stock are ignored and product is considered available
  // Or product has corresponding warehouseDetails chunk and is considered available
  if (variant.isGlobal || variant.warehouseDetails) {
    return true;
  }

  return false;
}

export function isPhysicalProductVariantInStock(variant?: ParsedProductVariant) {
  // Proudct variant with SKU not found, is missing warehouse details - not available in given warehouse, or is missing stock count
  if (!variant || !variant.warehouseDetails || variant.stockCount == null) {
    return false;
  }

  return (
    variant.stockCount - 1 >
    (variant.warehouseDetails.outOfStockThreshold || DEFAULT_OUT_OF_STOCK_THRESHOLD)
  );
}

export function isProductLowInStock(variant?: ParsedProductVariant) {
  if (!variant || variant.warehouseDetails?.fallbackStockThreshold == null || !variant.stockCount) {
    return false;
  }

  if (isPhysicalProduct(variant.productType)) {
    return variant.stockCount <= variant.warehouseDetails?.fallbackStockThreshold;
  }

  return false;
}

export function isProductVariantInStock(variant?: ParsedProductVariant | null) {
  if (!variant) {
    return false;
  }

  if (isPhysicalProduct(variant.productType)) {
    return isPhysicalProductVariantInStock(variant);
  }

  return isDigitalProductVariantInStock(variant);
}
